import React, { useEffect } from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { FailedApproaches } from '../components/FailedApproaches';
import { UniqueMechanism } from '../components/UniqueMechanism';
import { WhatYouGet } from '../components/WhatYouGet';
import { AudienceSection } from '../components/AudienceSection';
import { HowItWorks } from '../components/HowItWorks';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { OfferBlock } from '../components/OfferBlock';
import { trackPageView } from '../utils/metaPixel';
export function LandingPage() {
  useEffect(() => {
    trackPageView();
  }, []);
  return <main className="min-h-screen w-full" style={{
    backgroundColor: 'var(--color-background)'
  }} data-id="element-125">
      <Hero data-id="element-126" />
      <ProblemSection data-id="element-127" />
      <FailedApproaches data-id="element-128" />
      <UniqueMechanism data-id="element-129" />
      <WhatYouGet data-id="element-130" />
      <AudienceSection data-id="element-131" />
      <HowItWorks data-id="element-132" />
      <ProofSection data-id="element-133" />
      <FAQSection data-id="element-134" />
      <OfferBlock data-id="element-135" />

      {/* Footer */}
      <footer className="px-6 py-8 text-center" style={{
      backgroundColor: 'var(--color-background)'
    }} data-id="element-136">
        <p className="text-sm opacity-60" style={{
        color: 'var(--color-text)'
      }} data-id="element-137">
          © 2026 The 48-Hour Screen Detox. All rights reserved.
        </p>
      </footer>
    </main>;
}